import clsx from 'clsx';
import { Badge, badgeStyle, badgeType, fontWeight, IconButton, Text } from '../../../../../packages';
import { Box, Stack } from '@mui/material';
import RecentAssignmentsTable from '../../../../../pages/admin/plan-items/components/plan-item-detail/recent-assignments-table';
import { useStyles } from './RenderTable.style';

const RenderTable = props => {
  const { title, data, columns, onClickViewAll, renderMenuAction, className, onRowClick } = props;
  const classes = useStyles();

  const newColoumns = columns?.map(col => {
    if (col.id === 'level') {
      return {
        ...col,
        renderCell: val => {
          const key = val.toUpperCase();
          return (
            <Badge style={badgeStyle[key]} variant={badgeType.FILLED} className={classes.badge}>
              {val}
            </Badge>
          );
        },
      };
    }
    return col;
  });
  const { length } = data;
  return (
    <Box className={clsx(classes.tableWrap, className)} flex={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text className={classes.recentTitle} weight={fontWeight.SEMI_BOLD}>
          {title}
        </Text>
        {onClickViewAll && (
          <IconButton onClick={onClickViewAll} className={classes.viewAllBtn}>
            View top ({length})
          </IconButton>
        )}
      </Stack>
      <RecentAssignmentsTable
        className={classes.tableBordered}
        isShowAll={false}
        tableColumns={newColoumns}
        data={data}
        onRowClick={onRowClick}
        renderMenuAction={renderMenuAction}
      />
    </Box>
  );
};

export { RenderTable };
